import {useConfig} from '@aboutyou/config';
import {EmailSubscriptionType} from '@aboutyou/grpc-clients/grips/protos/email_subscriptions/v1/email_subscription.types';
import {useTranslation} from '@aboutyou/i18n';
import {useMemo} from 'react';

export const useUserSettingsPageTranslations = () => {
  const {t} = useTranslation();
  const {locale} = useConfig();

  return useMemo(() => {
    return {
      locale,
      countryAndLanguage: {
        title: t('Country'),
        description: t(
          'Choose a country where you would like to shop. You will have to log in again in the new shop.',
        ),
        country: t('Country'),
        chooseShop: t('Select shop'),
      },
      emailNotifications: {
        title: t('Email notification'),
        description: t(
          'Receive current trends, offers, vouchers and much much more directly by email. You can unsubscribe at any time for free.',
        ),
        allowEmailNotifications: t('Allow email notifications'),
        byType: {
          [EmailSubscriptionType.NEWSLETTER]: {
            title: t('ABOUT YOU Newsletter'),
            description: t(
              'Be the first to find out about current trends, personal vouchers and sales.',
            ),
          },
          [EmailSubscriptionType.SIZE_REMINDER]: {
            title: t('Your sizes'),
            description: t(
              'Be informed when one of your selected products is back in stock.',
            ),
          },
          [EmailSubscriptionType.WISHLIST_BASKET]: {
            title: t('Your wishlist and basket'),
            description: t(
              'Be informed as soon as a product on your wishlist is reduced or nearly sold out',
            ),
          },
          [EmailSubscriptionType.RECOMMENDATIONS]: {
            title: t('Your recommendations'),
            description: t(
              'Receive recommendations from us based on your orders.',
            ),
          },
          [EmailSubscriptionType.RATING]: {
            title: t('Your opinion'),
            description: t(
              'Receive relevant updates about your idols, brands, newsfeed, new followers & more. We will ask for your opinion on certain themes.',
            ),
          },
          [EmailSubscriptionType.EMAIL_SUBSCRIPTION_HOT_DROPS_INDIVIDUAL]: {
            title: t('ABOUT YOU Drops'),
            description: t(
              'Be the first in line to learn about our latest collections and sneaker drops.',
            ),
          },
        },
        notes: {
          confirmSubscription: t(
            'Please confirm your log in details by clicking on the link we have sent you by email.',
          ),
        },
      },
      pushNotifications: {
        title: t('Push notifications'),
        description: t(
          'Receive browser push notifications about your orders, personal vouchers and products that are back in stock.',
        ),
        allowPushNotifications: t('Allow push notifications'),
        browserHint: t(
          'You need to update your browser settings to receive browser notifications.',
        ),
      },
      settingsSaved: t('Your settings have been updated'),
      settingsFailedToSave: t('Error saving settings'),
      settingsFailedToLoad: t('Error loading settings'),
      settingsSavedConfirmationRequired: t(
        'Your settings have been updated. To activate your log in, confirm the confirmation email with one click.',
      ),
      retry: t('Try again'),
      close: t('Cancel'),
    };
  }, [t, locale]);
};
